import React, { useState, useEffect } from "react";
import "./App.css";
import { useNavigate } from "react-router-dom";
import Loader2 from "./Skleton/Loader2";

export default function Alertme() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [location, setLocation] = useState(null);
  const [emailError, setEmailError] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [fromLocalStorage, setFromLocalStorage] = useState("");
  const [registered, setRegistered] = useState(false);
  const [registeredSupport, setRegisteredSupport] = useState(true);
  const [shake, setShake] = useState(false); // State to trigger the shake animation
  const [isMobileView, setIsMobileView] = useState(false);
  const [isloading, setisloading] = useState(false);

  const [got, setgot] = useState("");

  const nav = useNavigate();

  const checkIsMobile = () => {
    setIsMobileView(window.innerWidth <= 768); // Adjust the width as needed
  };

  // Check if email has been submitted in local storage on component mount
  useEffect(() => {
    const storedEmail = localStorage.getItem("submittedEmail");
    if (storedEmail) {
      setFromLocalStorage(storedEmail);
      setSubmitted(true);
    }

    // Add an event listener to check screen size changes
    window.addEventListener("resize", checkIsMobile);

    // Initial check
    checkIsMobile();

    // Cleanup the event listener
    return () => {
      window.removeEventListener("resize", checkIsMobile);
    };
  }, []);

  useEffect(() => {
    if (shake) {
      const shakeTimeout = setTimeout(() => {
        setShake(false);
      }, 500); // Match the animation duration
      return () => clearTimeout(shakeTimeout);
    }
  }, [shake]);

  const handleLocationClick = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setLocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      });

      setgot("location fetched successfully");
    }
  };

  const validateEmail = (inputEmail) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return emailRegex.test(inputEmail);
  };

  // Handle registration submit
  const handleSubmit = async () => {
    if (!validateEmail(email)) {
      setEmailError("Please enter a valid email address");
      return;
    }

    setEmailError("");

    if (!location) {
      setEmailError("Please allow location access to register");
      setShake(true);
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("latitude", location.latitude); // Include latitude
    formData.append("longitude", location.longitude); // Include longitude

    setisloading(true);

    const response = await fetch(
      "https://otp-alertlocation.vercel.app/alertmeReg",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(Object.fromEntries(formData)),
      }
    );

    const data = await response.json();

    if (data === "done") {
      localStorage.setItem("submittedEmail", email);
      setFromLocalStorage(email);
      setSubmitted(true);
    } else {
      setEmailError("This email is already registered");
      setShake(true); // Trigger the shake animation
    }

    setisloading(false);
  };

  // Handle sign-in submit
  const handleSubmitForRegistered = async () => {
    if (!validateEmail(email)) {
      setEmailError("Please enter a valid email address");
      return;
    }

    setEmailError("");

    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    setisloading(true);

    const response = await fetch(
      "https://otp-alertlocation.vercel.app/alertmeSignin",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: formData, // Use the FormData object directly
      }
    );

    const data = await response.json();

    if (data === "done") {
      localStorage.setItem("submittedEmail", email);
      setFromLocalStorage(email);
      setSubmitted(true);
    } else {
      setShake(true); // Trigger the shake animation
      setEmailError("Wrong name or email");
    }

    setisloading(false);
  };

  return (
    <>
      {isloading ? (
        <>
          <Loader2 />
        </>
      ) : (
        <>
          <div className="flex justify-center items-center min-h-screen bg-gray-100">
            <div
              className={`bg-blue-50 rounded-lg shadow-xl p-6 w-70% sm:w-2/3 lg:w-1/2 xl:w-1/3 ${
                shake ? "shake" : ""
              } mt-[-7rem] sm:mt-0`}
            >
              {submitted ? (
                <>
                  <div
                    style={{
                      width: "100%",
                      height: "auto",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src="https://i.pinimg.com/originals/70/a5/52/70a552e8e955049c8587b2d7606cd6a6.gif" // Replace with your image URL
                      alt="Your Image"
                      style={{
                        height: "9rem",
                        width: "9rem",
                        borderRadius: "50%",
                      }}
                    />
                  </div>
                  <br />
                  <hr />
                  <hr />

                  <br />
                  <p className="text-lg">
                    You will be notified 🔔🔔 via {fromLocalStorage} mail id
                  </p>

                  <br />
                  <br />

                  <p
                    className="text-sm text-red-500"
                    onClick={() => nav("/alertmenewlocation")}
                  >
                    CHANGE YOUR NOTIFICATION LOCATION?
                  </p>
                  <br />
                  <p
                    className="text-sm text-blue-500"
                    onClick={() => {
                      localStorage.removeItem("submittedEmail");
                      window.location.href = "/alertme";
                    }}
                  >
                    Mute Email From this portal?
                  </p>
                </>
              ) : (
                <div>
                  <h1 className="text-2xl font-semibold mb-4">
                    HAVE YOU ALREADY REGISTERED WITH ANY EMAIL ID?
                  </h1>
                  <div className="mb-4">
                    <p
                      className={`cursor-pointer inline-block mr-4 px-4 py-2 rounded-lg ${
                        registered
                          ? "bg-gray-400 text-white"
                          : "bg-blue-75 text-gray-700"
                      }`}
                      onClick={() => {
                        setRegistered(true);
                        setRegisteredSupport(true);
                        setEmailError("");
                        setEmail("");
                        setName("");
                      }}
                    >
                      YES
                    </p>
                    <p
                      className={`cursor-pointer inline-block px-4 py-2 rounded-lg ${
                        !registered
                          ? "bg-gray-400 text-white"
                          : "bg-blue-75 text-gray-700"
                      }`}
                      onClick={() => {
                        setRegistered(false);
                        setRegisteredSupport(false);
                        setEmailError("");
                        setEmail("");
                        setName("");
                      }}
                    >
                      NO
                    </p>
                  </div>

                  {registered && registeredSupport ? (
                    <div className="bg-blue-75 p-4 rounded-lg shadow-md">
                      <div>
                        <label htmlFor="name" className="text-lg font-semibold">
                          Name:
                        </label>
                        <input
                          type="text"
                          id="name"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          className="block w-full border border-gray-300 p-2 rounded-lg mt-2 bg-blue-50"
                        />
                      </div>

                      <div className="mt-4">
                        <label
                          htmlFor="email"
                          className="text-lg font-semibold"
                        >
                          Email:
                        </label>
                        <input
                          type="email"
                          id="email"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                            setEmailError("");
                          }}
                          className="block w-full border border-gray-300 p-2 rounded-lg mt-2 bg-blue-50"
                        />
                        {emailError && (
                          <p className="text-red-500 mt-2">{emailError}</p>
                        )}
                      </div>

                      <button
                        onClick={handleSubmitForRegistered}
                        className="bg-gray-400 text-white p-2 mt-4 rounded-lg shadow-md hover:bg-gray-500"
                      >
                        Submit
                      </button>
                    </div>
                  ) : (
                    <div className="bg-blue-75 p-4 rounded-lg shadow-md">
                      <div>
                        <label htmlFor="name" className="text-lg font-semibold">
                          Name:
                        </label>
                        <input
                          type="text"
                          id="name"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          className="block w-full border border-gray-300 p-2 rounded-lg mt-2 bg-blue-50"
                        />
                      </div>

                      <div className="mt-4">
                        <label
                          htmlFor="email"
                          className="text-lg font-semibold"
                        >
                          Email:
                        </label>
                        <input
                          type="email"
                          id="email"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                            setEmailError("");
                          }}
                          className="block w-full border border-gray-300 p-2 rounded-lg mt-2 bg-blue-50"
                        />
                        {emailError && (
                          <p className="text-red-500 mt-2">{emailError}</p>
                        )}
                      </div>

                      <button
                        onClick={handleLocationClick}
                        className="bg-gray-400 text-white p-2 mt-4 rounded-lg shadow-md hover:bg-gray-500"
                      >
                        Press here to get your location
                      </button>

                      {got.length > 1 ? (
                        <>
                          <br />
                          <br />

                          <div className="setting">
                            {" "}
                            <p className="text-green-500">{got}</p>
                          </div>
                        </>
                      ) : (
                        <>
                          <br />
                          <br />
                          <div className="setting"></div>
                        </>
                      )}

                      {location && <></>}
                      <br />
                      <button
                        onClick={handleSubmit}
                        className="bg-blue-400 text-white p-2 mt-4 rounded-lg shadow-md hover:bg-gray-500"
                      >
                        ACTIVATE ALERT
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
}
